<template>
  <div class="pzy_group">
    <div class="pzy_t">
       <div class="pzy_tbox">
          <div class="pzy_tleft">
              <div class="pzy_lefttit">家庭配置药基础系列</div>
              <div class="pzy_leftsecond">条件</div>
              <div class="pzy_lefttxt on">基础系列配置后才可以购买补充药品</div>
              
              <div class="pzy_leftsecond">服务</div>
              <div class="pzy_lefttxt">过期免费更换服务</div>
              <div class="pzy_lefttxt">国际包邮 无需付运费</div>
              <div class="pzy_lefttxt">家庭医生微信群（制药团队服务用药指导）</div>
              <div class="pzy_lefttxt">人工智能24小时在线服务</div>
          </div>
          <div class="pzy_tright">
              <!-- <img
                class="package_img_style"
                :src="cgmPackage.packageImg"
                alt=""
                srcset=""
              /> -->
              <img
                src="../assets/img/cgm.png"
                alt=""
                srcset=""
              />
          </div>
       </div>
    </div>
    <div class="max_style">
      <div class="spu_layout_style">
        <div class="pzy_medicine">
          <div class="spu_for_style" v-for="item in cgmSpuList" :key="item.spuId">
            <div class="spu_style">
              <img class="spu_img_style" :src="item.spuImg" alt="" srcset="" />
              <div class="spu_bottom">
                <div class="spu_left">
                  <div class="cgm_spu">规格:{{ item.cgmSpuOption }}</div>
                  <div class="cgm_spu">
                      分类:<span 
                  v-for="item in item.cgmLabelList"
                :key="item.labelId"> {{ item.labelName }}</span> 
                  </div>
                  <div>
                    <span class="spu_name_style">{{ item.spuName }}</span>
                  </div>
                  <!-- <div class="spu_introduce_style">{{ item.spuIntroduce }}</div> -->
                </div>
                <div class="spu_right" @click="popup_click(item.spuId)">
                    <div class="spu_righttxt no">弹窗</div>
                    <div class="spu_righttxt">查看详情</div>
                </div>
              </div>
            </div>
          </div>
          <div class="total_layout_style">
            <div class="total_style">
              <div class="spukeep">CGM Pay国际支付公司担保</div> 
              <div class="spukeep">中国主流支付 自动换汇</div>
            </div>
            <div class="apply_style" @click="buy_click" v-loading="loading">
                <div>立刻申请配置药</div> 
                <div>￥{{ cgmPackage.rmbAmount }}</div> 
            </div>
          </div>
        </div>
        <!-- <div class="address_style1">支付方式</div>
        <div class="address_style">
          <div class="detail_style">
            <el-radio v-model="vendor" label="wechatpay">微信</el-radio>
            <el-radio v-model="vendor" label="alipay">支付宝</el-radio>
            <el-radio v-model="vendor" label="unionpay">银联</el-radio>
          </div>
        </div> -->
        <!-- <div class="total_layout_style">
          <div class="total_style">
            整套价格合计
            <span class="total_rmb_style">￥{{ cgmPackage.rmbAmount }}</span>
          </div>
          <div class="apply_style" @click="buy_click" v-loading="loading">
            立刻申请配置药
          </div>
        </div> -->
      </div>
      <el-dialog
        title="支付"
        :visible.sync="centerDialogVisible"
        center
        width="30%"
      >
        <div class="qr_style">
          <qrcode-vue
            :value="nihaopay_qr_code"
            :size="size"
            level="H"
          ></qrcode-vue>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="centerDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="pay_confirm_click">已支付</el-button>
        </span>
      </el-dialog>
    </div>
    <div class="pzy_popupbox" v-if="paypopupshow"></div>
    <div class="pzy_popupco"  v-if="paypopupcont">
      <div class="pzy_popup">
        <img class="pzy_popup_close" @click="popup_close" src="../assets/img/closem.png" alt="">
        <div class="pzy_popupcont">
          <div class="product_detail_content">
            <div class="pzy_medicinename">{{ spuVO.spuName }}</div>
            <div class="pzy_medicinenamedesc">{{ spuVO.spuIntroduce }}</div>
            <div class="product_detail_box">
              <div class="product_detail_tit">特长</div>
              <div v-html="spuVO.spuSpeciality"></div>
            </div>
            <div class="product_detail_box">
              <div class="product_detail_tit">使用注意事项</div>
              <div v-html="spuVO.spuCareful"></div>
            </div>
            <div class="product_detail_box">
              <div class="product_detail_tit">用法・剂量</div>
              <div v-html="spuVO.spuDosage"></div>
            </div>
            <div class="product_detail_box">
              <div class="product_detail_tit">功效・效果</div>
              <div v-html="spuVO.spuEffect"></div>
            </div>
            <div class="product_detail_box">
              <div class="product_detail_tit">成分・分量</div>
              <div v-html="spuVO.spuComponent"></div>
            </div>
            <div class="product_detail_box">
              <div class="product_detail_tit">存放和处理注意事项</div>
              <div v-html="spuVO.deposit"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { pcaTextArr } from "element-china-area-data";
import { Toast } from "vant";
import { mapState, mapMutations } from "vuex";
export default {
  computed: {
    ...mapState(["cgmUserVO", "leftItem"]),
  },
  data() {
    return {
      userAddress: null,
      province: null,
      city: null,
      district: null,
      address: null,
      receiving: null,
      receivingMobile: null,
      vendor: "alipay",
      pcaTextArr,
      selectedOptions: [],
      nihaopay_qr_code: null,
      size: 300,
      centerDialogVisible: false,
      paypopupshow:false,
      paypopupcont:false,
      loading: false,
      cgmPackage: {},
      cgmSpuList: [],
      spuVO: {},
    };
  },
  mounted() {
    this.cgmSpuRecords();
  },
  methods: {
    ...mapMutations(["setCgmUserVO", "setLeftItem"]),
    handleChange(value) {
      this.province = value[0];
      this.city = value[1];
      this.district = value[2];
    },
    cgmSpuRecords() {
      this.axios
        .get("/cgmSpu/getByPackageId", {
          params: {
            packageId: this.$route.query.packageId,
          },
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.cgmPackage = res.data.data;
            this.cgmSpuList = res.data.data.cgmSpuList;
          }
        });
    },
    // async buy_click() {
    //   if (this.cgmUserVO) {
    //     let userId = JSON.parse(this.cgmUserVO).userId;
    //     // let address_res = await this.axios.get("/cgmAddress/get", {
    //     //   params: {
    //     //     userId,
    //     //   },
    //     // });

    //     // let family_res = await this.axios.get("/cgmFamily/getMaster", {
    //     //   params: {
    //     //     userId,
    //     //   },
    //     // });

    //     // if (
    //     //   address_res.data.code == 200 &&
    //     //   address_res.data.data != null &&
    //     //   family_res.data.code == 200 &&
    //     //   family_res.data.data != null &&
    //     //   family_res.data.data.sex != null &&
    //     //   family_res.data.data.born != null &&
    //     //   family_res.data.data.cardId != null
    //     // ) {
    //       this.loading = true;
    //       this.axios
    //         .post(
    //           "/securePay",
    //           {
    //             userId,
    //             packageId: this.$route.query.packageId,
    //             province: this.province,
    //             city: this.city,
    //             district: this.district,
    //             address: this.address,
    //             receiving: this.receiving,
    //             receivingMobile: this.receivingMobile,
    //             vendor: this.vendor,
    //           },
    //           {
    //             headers: {
    //               "Content-Type": "application/x-www-form-urlencoded",
    //             },
    //           }
    //         )
    //         .then((res) => {
    //           if (res.data.code == 200) {
    //             let w = window.open("", "_self");
    //             w.document.write(res.data.data);
    //           }
    //           this.loading = false;
    //         });
    //     // } else {
    //     //   const ua = navigator.userAgent.toLowerCase();
    //     //   if (/phone|mobile|android|iphone|ipad|ipod/i.test(ua)) {
    //     //     // this.$router.push({
    //     //     //   path: "/userAddress",
    //     //     // });
    //     //     this.$router.push({
    //     //       path: "/userSelf",
    //     //       query: {
    //     //         familyId: family_res.data.data.familyId,
    //     //       },
    //     //     });
    //     //     Toast.fail("请完善个人情报、收货地址");
    //     //   } else {
    //     //     this.setLeftItem(4);
    //     //     this.$router.push({
    //     //       path: "/userCenter",
    //     //     });
    //     //     this.$message({ type: "error", message: "请先填写收货地址" });
    //     //   }
    //     // }
    //   } else {
    //     this.$router.push({ path: "/login" });
    //     this.$message({ type: "error", message: "请登录" });
    //   }
    // },
    async buy_click() {
      if (this.cgmUserVO) {
        // let userId = JSON.parse(this.cgmUserVO).userId;
          this.$router.push({
            path: "/Pay",
            query: {
              packageId:this.$route.query.packageId,
            },
          });
      } else {
        this.$router.push({ path: "/login" });
        this.$message({ type: "error", message: "请登录" });
      }
    },
    pay_confirm_click() {
      this.centerDialogVisible = false;
      this.$router.push({ path: "/order" });
    },
    popup_click(spuId){
      this.paypopupshow = true
      this.spu_detail(spuId)
      setTimeout(() => {
         this.paypopupcont = true
      }, 500);
    },
    popup_close(){
      this.paypopupcont = false
      setTimeout(() => {
        this.paypopupshow = false
      },100);
    },
    spu_detail(id) {
      this.axios
        .get("/cgmSpu/get", {
          params: {
            spuId: id,
          },
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.spuVO = res.data.data;
          }
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.spu_style{
  display: block;
}
.spu_bottom{
  font-size: 0;
}
@media (max-width:768px) {
  .package_style {
    flex-wrap: wrap;
  }
  .spu_style {
    flex-wrap: wrap;
    justify-content: center;
  }
  ::v-deep .el-dialog {
    width: 100% !important;
  }
  // .sp_style {
  //   padding: 0 10px;
  // }
  .spu_title_style {
    padding: 20px !important;
    width: 90% !important;
  }
  .apply_style {
    border-radius: 200px !important;
    width: 80% !important;
  }
  .total_layout_style {
    padding: 0 20px !important;
    box-sizing: border-box !important;
  }
  .package_img_style {
    width: 100% !important;
    height: 100% !important;
  }
}
.total_layout_style {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin: 15px 0 35px 0;
}
.total_style {
  margin: 20px 0;
  font-size: 20px;
  color: #333333;
}
.total_rmb_style {
  font-size: 28px;
  color: #e0000f;
}
.package_name_style {
  padding-top: 30px;
  font-size: 22px;
  color: #e0000f;
}
.package_na_style {
  margin: 10px 0 20px;
  font-size: 32px;
  color: #000;
  font-weight: bold;
}
.qr_style {
  display: flex;
  justify-content: center;
}
.detail_style {
  margin-bottom: 10px;
  margin-left: 20px;
}
.detail_style ::v-deep .el-input__inner {
  width: 320px;
}
.address_style {
  margin-bottom: 40px;
  background: #fff;
  border-radius: 10px;
  padding: 40px 0 40px 0;
}
.address_style1 {
  font-size: 18px;
  margin-bottom: 40px;
}
.spu_introduce_style {
  color: #9c9c9c;
  font-size: 0;
}
.spu_title_style {
  margin-bottom: 10px;
  font-size: 20px;
  font-weight: bold;
  width: 100%;
}
.spu_layout_style {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #f5f6f7;
}
.apply_style {
  background: #1161BA;
  color: #fff;
  padding: 10px 0;
  border-radius: 10px;
  text-align: center;
  font-size: 20px;
  cursor: pointer;
  width: 519px;
  // height: 91px;
}
.package_style {
  display: flex;
  align-items: center;
  background: #fff;
  border-radius: 10px;
  margin: 36px 0;
  font-size: 24px;
  width: 100%;
  padding: 20px;
  box-sizing: border-box;
}
.package_img_style {
  // width: 350px;
  height: 233px;
}
.pzy_medicine{
  width: 1165px;
  font-size: 0;
  padding:60px 0 100px;
  vertical-align: top;
}
.spu_for_style {
  box-sizing: border-box;
  display: inline-block;
  width: 268px;
  margin-right: 30px;
  border-radius: 20px;
  padding: 16px 16px 20px;
  margin-bottom: 20px;
  background-color: #fff;
}
.spu_for_style:nth-child(4n) {
  margin-right: 0;
}
// .spu_style {
//   display: flex;
//   align-items: center;
//   gap: 20px;
// }
.spu_img_style {
  width: 100%;
  margin-bottom: 20px;
}
.spu_name_style {
  font-size: 14px;
  color:#1161BA;
}
.spu_option_style {
  font-size: 16px;
  margin-left: 10px;
  color: #9c9c9c;
}
.right_layout_style {
  margin-bottom: 20px;
}
.lable_layout_style {
  display: flex;
  align-items: center;
  margin: 10px 0;
  column-gap: 4px;
}
.lable_style {
  font-size: 14px;
  padding: 9px 20px;
  color: #1b2a7e;
  text-align: center;
  background: #e9eff5;
  border-radius: 25px;
}
// 新版
.pzy_t{
 background-color:#01A7E3;
 padding:150px 0 120px;
}
.pzy_tbox{
  width: 1105px;
  font-size: 0;
  margin:0 auto;
}
.pzy_tleft{
  width: 660px;
  display: inline-block;
}
.pzy_tright{
  width: 445px;
  display: inline-block;
  vertical-align: top;
}
.pzy_lefttit{
  font-size: 42px;
  font-weight: bold;
  color: #fff;
  margin-bottom: 30px;
}
.pzy_leftsecond{
  font-size: 30px;
  font-weight: bold;
  color: #fff;
  margin-bottom: 15px;
}
.pzy_lefttxt{
  padding-left: 60px;
  position: relative;
  font-size: 26px;
  font-weight: bold;
  color: #fff;
  margin-bottom: 12px;
}
.pzy_lefttxt::after{
  position: absolute;
  left:0px;
  top:10px;
  content:'';
  width: 15px;
  height: 15px;
  border:3px solid #fff;
  border-radius: 50%;
}
.pzy_lefttxt.on{
  margin-bottom: 40px;
}
.pzy_tright img{
  width: 100%;
  height:auto;
}
.cgm_spu{
  font-size: 14px;
  margin-bottom: 5px;
  color:rgba(0,0,0,.56)
}
.spu_bottom{
  font-size: 0;
}
.spu_right,.spu_left{
  display: inline-block;
}
.spu_left{
  width: calc(100% - 70px);
}
.spu_right{
  width:70px;
  height: 70px;
  background: #1161BA;
  text-align: center;
  padding-top: 20px;
  box-sizing: border-box;
  border-radius: 5px;
  vertical-align: top;
}
.spu_righttxt{
  font-size: 14px;
  color:#fff;
}
.spukeep{
  box-sizing: border-box;
  font-size: 30px;
  padding-left:120px;
  position: relative;
}
.spukeep::after{
  position: absolute;
  content:'';
  left:70px;
  top:10px;
  width: 15px;
  height: 15px;
  border:3px solid #000;
  border-radius: 50%;
}
//弹窗样式
.pzy_popupbox{
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgba(64,64,64,0.54);
  left:0;
  top:0;
  z-index: 999;
}
.pzy_popupco{
  position: relative;
}
.pzy_popup{
  width: 88%;
  height: 80%;
  position: fixed;
  top: 0;
  left:0;
  right:0;
  bottom:0;
  margin:auto;
  background: #fff;
  box-sizing: border-box;
  padding:120px 70px;
  z-index: 1000;
  border-radius: 20px;
}
.pzy_popupcont{
overflow: auto;
height: 100%;
}
.pzy_popup_close{
  width: 30px;
  position: fixed;
  top:calc(10% + 60px);
  right:calc(6% + 50px);
}
.pzy_medicinename{
  font-size: 35px;
  margin-bottom: 33px;
  font-weight: 600;
}
.pzy_medicinenamedesc{
  font-size: 30px;
  line-height: 2;
}
.product_detail_tit{
  font-size: 30px;
  font-weight: bold;
  padding:55px 0 10px;
}
::v-deep table {
  width: 100%;
  border-collapse: collapse;
}
::v-deep table tr:first-child {
  height: 50px;
  text-align: center;
  background: rgb(231, 231, 231);
}
::v-deep td {
  border: 1px solid #bfc7d4;
}
::v-deep td:not(:nth-child(1):nth-child(2)) {
  padding: 14px;
}
.pay_popup{
  box-sizing: border-box;
  position: absolute;
  width: 100%;
  height: calc(100vh - 61px);
  z-index: 100;
  top:61px;
  left:0;
}
.pay_popupcont{
  
}
@media screen and (max-width:1250px) {
  .pzy_tbox{
    width: 90%;
  }
  .pzy_tleft{
    width: 55%;
  }
  .pzy_tright{
    width: 45%;
  }
  .pzy_medicine{
    width: 90%;
  }
  .spu_for_style{
    margin-right: 15px;
    width: 255px;
    padding:15px 12px 20px;
  }
}
@media screen and (max-width:1250px) {
  .spu_for_style:nth-child(4n){
    margin-right: 15px;
  }
  .spukeep{
     padding-left: 80px;
  }
  .spukeep::after{
    left:40px;
  }
  .apply_style{
    width: 380px;
  }
  .spu_left{
    width: calc(100% - 60px);
  }
  .spu_right{
    padding-top: 15px;
    width:60px;
    height: 60px;
  }
  .spu_righttxt{
    font-size: 12px;
  }
  .total_layout_style{
    padding-right: 50px;
  }
}
@media screen and (max-width:1000px) {
  .pzy_t{
    padding:50px 0 40px;
  }
    .pzy_tleft{
      width: 100%;
      margin-bottom: 20px;
    }
    .pzy_lefttit{
      font-size: 30px;
      margin-bottom: 20px;
    }
    .pzy_leftsecond{
      font-size: 20px;
      margin-bottom: 10px;
    }
    .pzy_lefttxt{
      font-size: 18px;
      padding-left: 20px;
    }
    .pzy_lefttxt::after{
      width: 10px;
      height: 10px;
      border-width: 2px;
      top:5px;
    }
    .pzy_tright{
      display: block;
      margin:0 auto;
    }
    .spu_for_style{
      width: calc(50% - 10px);
      margin-right: 18px;
    }
    .spu_for_style:nth-child(4n){
      margin-right: 0;
    }
    .spu_for_style:nth-child(2n){
      margin-right: 0;
    }
    .spu_left{
      display: block;
      width: 100%;
    }
    .spu_right{
      display: block;
      height: 32px;
      line-height: 32px;
      width: 100px;
      padding-top: 0;
    }
    .spu_righttxt.no{
      display: none;
    }
    .cgm_spu{
      font-size: 12px;
    }
    .spu_name_style{
      height: 40px;
      display: block;
    }
    .total_layout_style{
      display: block;
    }
    .total_style{
      margin-bottom:10px;
    }
    .spukeep{
      padding-left: 30px;
      margin-bottom: 5px;
      font-size: 16px;
    }
    .spukeep::after{
      width: 8px;
      height: 8px;
      left: 10px;
      top:5px;
      border-width: 1px;
    }
    .apply_style{
      width: 100%!important;
      font-size: 16px;
    }
    .total_layout_style{
      padding:0!important;
    }
    .pzy_medicine{
      padding-bottom: 40px;
    }
    .pzy_popup{
      padding:50px 20px;
    }
    .pzy_popup_close{
      width: 18px;
      height: auto;
      top: calc(10% + 20px);
      right: calc(6% + 5px);
    }
    .pzy_medicinename{
      font-size: 22px;
      margin-bottom: 10px;
    }
    .pzy_medicinenamedesc{
      font-size: 16px;
      line-height: 1.8;
      margin-bottom: 0;
    }
    .product_detail_tit{
      font-size:18px;
      padding:30px 0 10px;
    }
}
</style>